import { Box, PaginationItem } from '@mui/material'
import usePagination from '@mui/material/usePagination'
import { withoutFinalPage } from '@tnf-recruit/shared'

/**
 * Page controls for a long list. Looks like MUI's `Pagination`, but the last page's
 * number is left out while an ellipsis stands in for it, so the list never announces
 * how many pages there are.
 */
export function ListPagination({
  count,
  page,
  onChange,
}: {
  count: number
  page: number
  onChange: (page: number) => void
}): JSX.Element {
  const { items } = usePagination({ count, page, onChange: (_, value) => onChange(value) })

  return (
    <Box component="nav" aria-label="pagination navigation">
      <Box
        component="ul"
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          p: 0,
          m: 0,
          listStyle: 'none',
        }}
      >
        {withoutFinalPage(items, count).map((item, index) => (
          <li key={index}>
            <PaginationItem color="primary" {...item} />
          </li>
        ))}
      </Box>
    </Box>
  )
}
